import cep from "cep-promise";

const PROVIDERS = ["brasilapi", "viacep"];

export class CEPService {
  /**
   * Busca os dados de um CEP.
   * --
   * @param {string} cepString
   * @returns {Promise<{
   *   cep: string,
   *   cidade: string,
   *   estado: string,
   *   rua: string,
   *   bairro: string,
   * }>}
   */
  async buscarDadosDoCep(cepString) {
    const response = await cep(cepString, {
      providers: PROVIDERS,
    });

    return {
      bairro: response.neighborhood,
      cep: response.cep,
      cidade: response.city,
      estado: response.state,
      rua: response.street,
    };
  }

  /**
   * Remove qualquer caractere que não seja número,
   * preservando zeros à esquerda.
   * --
   * @param {string|number|null} cepValue
   * @returns {string}
   */
  limparCep(cepValue) {
    return `${cepValue ?? ""}`.replace(/\D/g, "");
  }

  /**
   * Verifica se o CEP possui exatamente 8 dígitos.
   * --
   * @param {string|number|null} cepValue
   * @returns {boolean}
   */
  cepEhValido(cepValue) {
    return this.limparCep(cepValue).length === 8;
  }

  /**
   * Converte um CEP para inteiro.
   * Ex.: "99999-999" => 99999999
   * --
   * Retorna null caso o CEP seja inválido.
   * --
   * @param {string|number|null} cepValue
   * @returns {number|null}
   */
  getCepInteiro(cepValue) {
    const cepLimpo = this.limparCep(cepValue);

    if (cepLimpo.length !== 8) {
      return null;
    }

    return Number.parseInt(cepLimpo, 10);
  }
}

export default new CEPService();
